import {on, findIn, findAllIn} from "@elements/dom-utils";
import {onFind} from "@elements/init-modules-in-scope";
import {translate} from '@elements/translations';



export function init () {
    onFind('.js-max-checkbox-selection', function (baseElement) {
        let selectedCount = 0;

        let checkboxes = findAllIn('input[type="checkbox"]', baseElement);

        checkboxes.forEach((checkbox) => {
          on('change', () => {
              let checkedCheckboxes = findAllIn('input[type="checkbox"]:checked', baseElement);
                if (checkedCheckboxes.length > 2) {
                    checkbox.checked = false;
                }
            }, checkbox);
        });
    });
}

